import Section from "../components/Section/Section.jsx";
import CertificationContainer from "../components/Certification/CertificationContainer.jsx";
import { usePageMeta } from "../hooks/usePageMeta";

function AllCertifications() {
  usePageMeta({
    ogType: "website",
    ogUrl: window.location.href,
  });

  return (
    <Section headingText="All Certifications">
      <CertificationContainer />
    </Section>
  );
}

export default AllCertifications;
